import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IFrotaModel } from 'src/app/frota/model/frota.model';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { environment } from 'src/environments/environment';
import { IFiltroSubFrotaModel, ISubFrotaModel } from '../model/subFrota.model';
import { SubfrotaService } from '../subfrota.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

enum TipoEntidades {
  ctf = 1,
  frota = 2,
  posto = 3,
  macro = 8
}

enum Permissoes {
  inclusao = 86,
  exclusao = 87,
  alteracao = 88,
  consulta = 89,
  veiculos = 1344
}

@Component({
  selector: 'app-subfrota',
  templateUrl: './subfrota.component.html',
  providers: [{
    provide: MAT_RADIO_DEFAULT_OPTIONS,
    useValue: { color: 'primary' },
  }],
  styleUrls: ['./subfrota.component.scss']
})

export class SubfrotaComponent implements OnInit, OnDestroy {

  public urlTransferirVeiculos!: string;

  tipoEntidades = TipoEntidades;

  usuario !: LoginModel | undefined;

  private subs = new Subscription();

  isCollapsed!: boolean;
  ufs!: any[];

  displayedColumns!: string[];

  filtro!: IFiltroSubFrotaModel;

  public dataSource!: MatTableDataSource<ISubFrotaModel>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = 0;

  permissaoTransferirVeiculos: boolean = false;
  permissaoIncluir: boolean = false;
  permissaoAlterar: boolean = false;
  permissaoExcluir: boolean = false;
  permissaoConsultar: boolean = false;


  constructor(private subFrotaService: SubfrotaService,
              private authenticationService: AuthenticationService,
              private snackBar: SnackBarService,
              private renderer: Renderer2,
              private router: Router) {

    // Inicialização do Filtro e das colunas do Material Table que precisam ficar no Constructor

    this.filtro = { guid: this.subFrotaService.usuario.retorno.guid, uf: "", flagCentroCusto: "" };

    this.usuario = this.subFrotaService?.usuario;

    if (this.usuario.retorno.tipo === this.tipoEntidades.frota) {
      this.displayedColumns = ['actions', 'codigo', 'codigoIdentificacao', 'descricao', 'cidade', 'uf', 'flagCentroCusto', 'flagPadrao', 'cnpj', 'qtdeVeiculos'];
    } else {
      this.displayedColumns = ['actions', 'codigo', 'codigoIdentificacao', 'descricao', 'cidade', 'uf', 'flagCentroCusto', 'flagPadrao', 'cnpj', 'codigoFrota', 'nomeReduzidoFrota', 'qtdeVeiculos'];
    }

  }

  ngOnInit(): void {

    // Liga a animação de Loading (Spinner) na tela
    this.loading++;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {

          this.iniciar();

        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  private iniciar() {

    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? "PADRAO");

    this.urlTransferirVeiculos = CONFIG_URLS_API.URL_CadastroVeiculos + this.subFrotaService.usuario.retorno.guid;

    // Verifica as permissões individuais para as operações do CRUD (Incluir, Alterar, Consultar, Excluir, Transferir Veículos)
    this.permissaoTransferirVeiculos = this.verificaPermissao(Permissoes.veiculos);
    this.permissaoIncluir = this.verificaPermissao(Permissoes.inclusao);
    this.permissaoAlterar = this.verificaPermissao(Permissoes.alteracao);
    this.permissaoExcluir = this.verificaPermissao(Permissoes.exclusao);
    this.permissaoConsultar = this.verificaPermissao(Permissoes.consulta);

    this.ufs = this.subFrotaService.returnAllUfs();

    // Recupera o Filtro salvo na SessionStorage devido a navegação das telas (componentes).
    this.recuperaFiltroFrota();

    // Se usuário for de Frota ou Macro já realiza a consulta ao abrir a tela, senão é necessário escolher a frota antes de filtrar.
    if ((this.usuario?.retorno?.tipo === this.tipoEntidades.frota || this.usuario?.retorno?.tipo === this.tipoEntidades.macro) || (this.filtro.codigoFrota)) {

      this.isCollapsed = true;
      this.filtrar();

    }
    else {

      this.isCollapsed = false;

    }
  }

  private verificaPermissao(permissao: number) {
    return (this.usuario?.retorno?.permissoes ?? [{ codigoPermissao: 0 }]).filter(p => p.codigoPermissao === permissao).length > 0;
  }

  private recuperaFiltroFrota() {
    if (sessionStorage.getItem('filtroSubFrota')) {
      var localFiltro = JSON.parse(sessionStorage.getItem('filtroSubFrota') ?? '{}');
      if (localFiltro.guid === this.filtro.guid) {
        this.filtro = localFiltro;
      }
      sessionStorage.removeItem('filtroSubFrota');
    }

    if (sessionStorage.getItem('filtroFrota')) {

      var filtroFrota = JSON.parse(sessionStorage.getItem('filtroFrota') ?? '{}');
      this.filtro.codigoFrota = undefined;

      if (filtroFrota.guid === this.subFrotaService.usuario.retorno.guid) {
        if (filtroFrota.frota && filtroFrota.frota.codigo) {
          this.filtro.codigoFrota = filtroFrota.frota.codigo
        }
      } else {
        sessionStorage.removeItem('filtroFrota');
      }
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }


  onSubmit() {
    this.filtrar();
  }

  getXLSName(): string {
    const now = new Date();

    var name = 'CTF_ConsultaSubFrota_' + this.subFrotaService.usuario.retorno.codigoEntidade + '_'
      + this.subFrotaService.usuario.retorno.nomeFantasia + '_'
      + this.subFrotaService.usuario.retorno.login + '_'
      + now.toISOString();

    return name;
  }

  rowAction(actionType: any, rowElement: any) {

    this.subFrotaService.codigoSubFrota = rowElement.codigo;
    this.router.navigateByUrl('/subfrota/' + actionType);

  }

  selecionaFrota(frota: IFrotaModel | null) {
    if (!frota || !frota.codigo) {
      this.filtro.codigoFrota = null;
    } else {
      this.filtro.codigoFrota = frota.codigo;
    }
  }

  private filtrar() {

    if (this.usuario?.retorno?.tipo != this.tipoEntidades.frota && this.usuario?.retorno?.tipo != this.tipoEntidades.macro && !this.filtro.codigoFrota) {

      this.snackBar.flashMessage('Favor selecionar uma Frota no filtro.', ['snackbar-error'], 'Fechar', 0);

    } else {

      this.loading++;

      this.subs.add(this.subFrotaService.getSubFrotas(this.filtro)
        .subscribe({
          next: (res) => {
            if (res?.sucesso) {
              this.dataSource = new MatTableDataSource<ISubFrotaModel>(res.retorno);
              this.dataSource.paginator = this.paginator;
              this.sort.sort(({ id: '', start: 'desc' }) as MatSortable);
              this.dataSource.sort = this.sort;
              this.sort.sort(({ id: 'codigo', start: 'asc' }) as MatSortable);
              this.sort.disableClear = true;
              this.dataSource.sort = this.sort;
            }
          },
          complete: () => {
            this.loading--;
          }
        }));
    }
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
    sessionStorage.setItem('filtroSubFrota', JSON.stringify(this.filtro));
  }

}

